import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SubscriptionDataService } from 'src/app/account/services/subscription-data.service';
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';
import { filter, find, findIndex, forEach, get, includes, isEmpty, isUndefined, some, map as _map, capitalize as _capitalize, set, concat as _concat, 
groupBy as _groupBy, keys as _keys, mapValues as _mapValues, orderBy as _orderBy, uniqBy as _uniqBy, castArray as _castArray, 
pick as _pick, divide as _divide, round as _round, first as _first } from 'lodash-es';
import { NS_Enums, NS_SubscriptionPlanCard, NS_SubscriptionService, million } from 'src/app/shared/namespaces';
import { Router } from '@angular/router';
import { Options } from '@rp3e11/ngx-slider';
import { Observable, forkJoin, from, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { getBillingCycle, getFromDescription, getObjectKeyOrString, nFormatter } from 'src/app/shared/helpers/helpers';
import { CacheService } from 'src/app/cache.service';
import { AppService } from 'src/app/app.service';
import { CommonDialogComponent } from 'src/app/common-dialog/common-dialog.component';
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingComponent implements OnInit, OnDestroy {
  callbackNameEnum = NS_Enums.callbackNameEnum;
  trialSubscriptionPlanName = NS_SubscriptionService.trialSubscriptionPlanName;
  growthPlanNames = NS_SubscriptionService.growthCardSubscriptionPlanGroups;
  UPGRADED = NS_SubscriptionService.UPGRADED;
  SUSPENDED = NS_SubscriptionService.SUSPENDED;
  capitalize = _capitalize
  castArray = _castArray
  selectedPlanIndexGroupedByBillingCycle: number;
  options: Options;
  cycles = new Array<{billingDays: string, displayValue: string}>();
  selectedBillingCycle : {
    billingDays: string,
    displayValue: string
  };
  showSlider: boolean;
  onBillingCycleChange(value: any) {
    this.selectedBillingCycle = find(this.cycles, (x) => {
      return x.billingDays == value;
    });
    this.updateSubscriptionPlans(true);
  };
  // sliderConfig = {
  //   disabled : false,
  //   max : 100,
  //   min : 0,
  //   tickInterval : 1,
  //   step : 10,
  //   thumbLabel : true,
  //   value : 0
  // }
  pricingData = [

    // {
    //   heading: "Free",
    //   headingClass: "free-heading",
    //   text: "Move small volumes of data from business tools",
    //   dollar: "$",
    //   event: "events",
    //   connector: "selected_connector",
    //   plan: "free",
    //   innerHeading: "What's Included",
    //   keys: [
    //     {key: "50+ selected connectors"},
    //     {key: "Free initial load"},
    //     {key: "Upto 5 users"},
    //     {key: "24x7 email support"},
    //     {key: "SOC2, GDPR, CCPA compliance"},
    //   ]
    // },
    {
      heading: "Lite",
      headingClass: "free-heading",
      text: "Move small volumes of data from business tools",
      dollar: "$",
      event: "events",
      connector: "selected_connector",
      plan: "lite",
      innerHeading: "What's Included",
      // keys: [
      //   {key: "50+ selected connectors"},
      //   {key: "Free initial load"},
      //   {key: "Upto 5 users"},
      //   {key: "24x7 email support"},
      //   {key: "SOC2, GDPR, CCPA compliance"},
      // ]
    },
    {
      heading: "Growth",
      headingClass: "growth-heading",
      text: "Move all data from databases and business tools",
      dollar: "multiple_$",
      plan: "growth",
      innerHeading: "Everything in Lite +",
      plans: [],
      // keys: [
      //   {key: "150+ connectors"},
      //   {key: "On-demand events"},
      //   {key: "Unlimited users"},
      //   {key: "One time setup assistance"},
      //   {key: "24x7 live chat support"},
      // ]
    },
    { 
      heading: "Enterprise",
      headingClass: "enterprise-heading",
      text: "Move all data with best-in-class security and support",
      plan: "enterprise",
      quote: "quote",
      innerHeading: "Everything in Growth +",
      // keys: [
      //   {key: "Custom Row limits"},
      //   {key: "Slack Support"},
      //   {key: "Early access to New connectors"},
      //   {key: "Granular permissions (RBAC)"},
      //   {key: "Saras Templates"},
      //   {key: "Configuration Cloning"},
      //   {key: "Dedicated Relationship Manager"},
      //   {key: "24/7 Email, Chat & Slack Support"}
      // ]
    }
  ];

  constructor(private router: Router, public  subscriptionBusinessService: SubscriptionBusinessService, private subscriptionDataService : SubscriptionDataService,
    private cacheService: CacheService, private appService: AppService, private cdr: ChangeDetectorRef) { }
  eventsSubjectSubscription: any;
  //private growthPlans = [];
  selectedSubscriptionPlan: any;
  productRulesMap = new Map<string, any>();
  haveModifyPermissions = false;
  userDetails;
  ngOnInit(): void {
    const user_details = this.cacheService.getObject<any>(NS_Enums.cacheKeysEnum.user_details);
    if (!user_details) {
      this.appService.getUser().then((user) => {
        this.userDetails = user;
        this.cacheService.putObject(NS_Enums.cacheKeysEnum.user_details, user, true);
        this.haveModifyPermissions = this.subscriptionBusinessService.checkNewSubscriptionModifyPersmission(this.userDetails);
        this.cdr.markForCheck();
      })
    } else{
      this.haveModifyPermissions = this.subscriptionBusinessService.checkNewSubscriptionModifyPersmission(user_details);
    }
    
    if(!isUndefined(this.subscriptionBusinessService.subscriptionPlans) && !isEmpty(this.subscriptionBusinessService.subscriptionPlans)  && this.options ==undefined){
      this.updateSubscriptionPlans();
    } else{
      this.subscriptionBusinessService.refreshData();
    }
    this.eventsSubjectSubscription = this.subscriptionBusinessService.eventsSubject.subscribe((event: NS_SubscriptionService.eventsSubjectData) => {
      if(event.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.subscriptionPlans){
        this.updateSubscriptionPlans();
        this.cdr.markForCheck();
      }
      if(event.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.currentlyActiveCompanySubscription){
        this.haveModifyPermissions = this.subscriptionBusinessService.checkNewSubscriptionModifyPersmission(this.userDetails);
        this.updateSubscriptionPlans();
        this.cdr.markForCheck();
      }
      if(event.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.subscriptionPaymentSuccess){
        this.router.navigate([`/${this.subscriptionBusinessService.baseWord}/account/subscription/overview`]);
      }
    });
  }

  ngOnDestroy(): void {
    if(this.eventsSubjectSubscription){
      this.eventsSubjectSubscription.unsubscribe();
    }
  }

  // onSliderValueChange(event: any){
  //   console.log('onSliderValueChange' , event);
  //   this.selectedSubscriptionPlan = this.growthPlans[event.value / 10];
  // }
  plansGroupedByBillingCycle = {};
  otherCardPlans = {};
  private updateSubscriptionPlans(onBillingCycleChange = false){
    //if any plan is matching with currently active plan then show plans with same billing cycle
    let plansGroupedByBillingCycleObject = {};
    let growthCardPlans = filter(this.subscriptionBusinessService.subscriptionPlans, (plan) => {
      return includes(NS_SubscriptionService.growthCardSubscriptionPlanGroups, plan.subscriptionPlanGroup ) && plan.managedBySarasOnly == false;
    })
    if(isEmpty(growthCardPlans)) {
      return
    }
    this.cycles = _map(_uniqBy(growthCardPlans, 'billingDays'), plan => {
      return {
        billingDays: plan.billingDays,
        displayValue: `${getBillingCycle(plan.billingDays, false)}`
      }
    })

    this.otherCardPlans = this.getOtherCardPlans();
    console.log(this.otherCardPlans);

    plansGroupedByBillingCycleObject = _groupBy(growthCardPlans, 'billingDays')

    this.generateStrikeOutValueForYearlyPlan(plansGroupedByBillingCycleObject);
    
    this.plansGroupedByBillingCycle = _mapValues(plansGroupedByBillingCycleObject, (group) => {
      return _orderBy(group, ['basePrice'], ['asc'])
    });

    console.log(this.plansGroupedByBillingCycle)
    this.cycles = this.cycles.sort((a: any, b: any) => {
      return a.billingDays - b.billingDays;
    });
    if(onBillingCycleChange){
      //TODO get linked plan
    } else {
      this.selectedBillingCycle = find(this.cycles, (cycle)=>{
        return cycle.billingDays === get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','billingDays'] );
      });
      if(isUndefined(this.selectedBillingCycle)){
        if(this.subscriptionBusinessService.showMigrationFlowInPricingPage){
          this.selectedBillingCycle = find(this.cycles, (cycle)=>{
            return cycle.billingDays === this.subscriptionBusinessService?.newSubscriptionPlanMatchingOldSubscription?.billingDays;
          });
        } else {
          this.selectedBillingCycle = _first(this.cycles);
        }
        
      }
    }
    // let growthPlansWithActiveBillingCycle = filter(this.subscriptionBusinessService.subscriptionPlans, (plan: any) => {
    //   if(isActivePlanExistInSubscriptionPlans && this.subscriptionBusinessService.currentlyActiveCompanySubscription){
    //     return plan.billingDays == this.subscriptionBusinessService.currentlyActiveCompanySubscription.subscriptionPlan.billingDays;
    //   } else {
    //     //if no active subscription then show all daton plans
    //     return true;
    //   }
    // }).sort((a: any, b: any) => {
    //   return a.basePrice - b.basePrice;
    // });
    //this.growthPlans = growthPlansWithActiveBillingCycle;
    if(this.selectedBillingCycle?.billingDays){
      let activeIndex = findIndex(this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays], (plan: any) => {
        return plan.subscriptionPlanIdentifier === get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','subscriptionPlanIdentifier']) && 
        plan.subscriptionPlanGroup === get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','subscriptionPlanGroup'])
      });
      //this.sliderConfig.max = (this.growthPlans.length - 1) * 10;
      this.selectedSubscriptionPlan = activeIndex > -1 ? this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays][activeIndex] : this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays][0];
      this.updateGrowthHeadingBulletPoints();
      this.updateEnterprisePlanHeadingBulletPoints();
      this.selectedPlanIndexGroupedByBillingCycle = activeIndex > -1 ? activeIndex  : 0;
      this.updateProductRulesMapNew();
    }
  }

  private updateEnterprisePlanHeadingBulletPoints(){
    const enterprisePlan = find(this.subscriptionBusinessService.subscriptionPlans,(plan)=>{
      return includes(NS_SubscriptionService.enterpriseCardSubscriptionPlanGroup, plan?.subscriptionPlanGroup ) ;
    })

    const enterpriseHeading = getFromDescription(enterprisePlan?.description, 'planHeading');
    const enterpriseBulletPointkeys = getFromDescription(enterprisePlan?.description, 'bulletPoints')
    if(!isEmpty(enterpriseHeading)){
      // this.pricingData[0].innerHeading = heading;
      set(this.pricingData, [1, 'innerHeading'], enterpriseHeading)
    }
    if(!isEmpty(enterpriseBulletPointkeys)){
      // this.pricingData[1].keys = enterpriseBulletPointkeys.map((point: any) => {
      //   return {key: point};
      // });
    }
  }

  private loadGrowthSlider(){
    // If more than one card is shown in UI, then add new slider with new plan belonging to groups
    this.showSlider = false
    let stepsArray = this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays].map((plan: any, indexOfPlanGroupedByBillingCycle: number) => {
      let sliderValue: string;
      try {
        sliderValue = get(JSON.parse(get(plan, 'description')), 'sliderValue');
      } catch (error) {
        sliderValue = 'NA'
      }
      
      return { value: indexOfPlanGroupedByBillingCycle, legend: sliderValue  }
    });
    let isActivePlanExistInSubscriptionPlans = some(this.subscriptionBusinessService.subscriptionPlans, (plan: any) => {
      return includes(NS_SubscriptionService.growthCardSubscriptionPlanGroups, get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','subscriptionPlanGroup']) ) &&
      plan.id == get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','id'], -1 );
    });
    const disabled = isActivePlanExistInSubscriptionPlans && get(this.subscriptionBusinessService.currentlyActiveCompanySubscription, ['subscriptionPlan','billingDays'], -1 ) != this.selectedBillingCycle?.billingDays

    let options = {
      showTicks: true,
      showTicksValues: false,
      hideLimitLabels: true,
      translate: (value: number): string => {
        return '';
      },
      stepsArray: stepsArray
    };

    this.options = Object.assign({}, options, {disabled: disabled });
    setTimeout(() => {
      this.showSlider = true;
      this.cdr.markForCheck();
    }, 0)
  }
  onSliderPositionChange(event: any){
    this.selectedSubscriptionPlan = this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays][event.value];
    this.updateGrowthHeadingBulletPoints();
  }

  private updateGrowthHeadingBulletPoints(){
    const growthHeading = getFromDescription(this.selectedSubscriptionPlan?.description, 'planHeading');
    const growthBulletPointkeys = getFromDescription(this.selectedSubscriptionPlan?.description, 'bulletPoints')
    if(!isEmpty(growthHeading)){
      // this.pricingData[0].innerHeading = heading;
      set(this.pricingData, [0, 'innerHeading'], growthHeading)
    }
    if(!isEmpty(growthBulletPointkeys)){
      // this.pricingData[0].keys = growthBulletPointkeys.map((point: any) => {
      //   return {key: point};
      // });
    }
    this.pricingData = [...this.pricingData];
  }

  trackByBulletPoint(index : number, obj: any){
    return getObjectKeyOrString(obj, 'key')
  }

  private updateProductRulesMapNew(){
    let apiCalls=[];
    forEach(this.plansGroupedByBillingCycle[this.selectedBillingCycle.billingDays], (plan)=>{
      let apiCall = this.subscriptionDataService.subscriptionPlan.getSubscriptionPlanDetails(plan.id).pipe(catchError(error => {
        console.error(`Error in API call getSubscriptionPlanDetails -planId-${plan.id}:`, error);
        return throwError(error);
      }));
      apiCalls.push(apiCall);
    })

    forkJoin(apiCalls).subscribe((data)=>{
      forEach(data, (response) => {
        const productRules = get(response, ['productRules'], []);
        const planId = get(response, ['subscriptionPlan','id'], -1);
        const rowsInMillion = find(productRules , (rule: any) => {
          return includes(rule.ruleName, NS_SubscriptionService.leversEnum.NUMBER_OF_ROWS)
        })?.ruleValue;
        let displayValue = undefined;
        if(rowsInMillion){
          const rowsInNumber = parseInt((parseFloat(rowsInMillion) * million).toString()) ;
          displayValue =  nFormatter(rowsInNumber, 1);
        }

        this.productRulesMap.set(planId, displayValue ? `${displayValue}` : 'NA' );
      });
      this.loadGrowthSlider();
      this.cdr.markForCheck();
    });
  }

  onSelectPlanClick(selectedPlan){
    this.subscriptionBusinessService.changeToNewSubscriptionPlan(selectedPlan.id);
  }

  getOtherCardPlans() {
    const filterGrowthPlans = filter(this.subscriptionBusinessService.subscriptionPlans, plan => {
      return !includes(NS_SubscriptionService.growthCardSubscriptionPlanGroups, plan.subscriptionPlanGroup)
    })
    // Group by `subscriptionPlanGroup`
    const groupedBySubscriptionPlanGroup = _groupBy(filterGrowthPlans, 'subscriptionPlanGroup');
    
    const groupedByBillingDays = {};

    // Iterate through each group in the object
    forEach(_keys(groupedBySubscriptionPlanGroup), group => {
      // Flatten the structure to easily manipulate it
      const plans = groupedBySubscriptionPlanGroup[group];
      
      // Group by 'billingDays'
      const grouped = _groupBy(plans, 'billingDays');
      
      // Sort each group by `basePrice` &
      // Assign the grouped data back to the respective group
      groupedByBillingDays[group] = _mapValues(grouped, (group) => {
        return _orderBy(group, ['basePrice'], ['asc'])
      });
    });
    return groupedByBillingDays;
  }

  generateStrikeOutValueForYearlyPlan(plansGroupedByBillingCycleObject) {
    let yearlyPlans = get(plansGroupedByBillingCycleObject, NS_SubscriptionService.billingDaysEnums.YEARLY);
    const monthlyPlans = get(plansGroupedByBillingCycleObject, NS_SubscriptionService.billingDaysEnums.MONTHLY);
    let monthlyPlansBillingDaysBasePriceMap = {}
    forEach(monthlyPlans, plan => {
      monthlyPlansBillingDaysBasePriceMap[plan.subscriptionPlanIdentifier] = plan.basePrice
    })

    yearlyPlans = _map(yearlyPlans, plan => {
      return {
        ...plan,
        strikeOutPrice: monthlyPlansBillingDaysBasePriceMap[plan.subscriptionPlanIdentifier],
        displayPrice: _round(_divide(_divide(plan.basePrice, 12), 1))
      }
    })
    set(plansGroupedByBillingCycleObject, NS_SubscriptionService.billingDaysEnums.YEARLY, yearlyPlans)
  }

  // formatDisplayWith(value){
  //   return (value)=>{
  //     return `${this.productRulesMap.get(this.selectedSubscriptionPlan.id)}M`;
  //   };
  // }

}
